<main>
  <div class="max-w-screen-xl pb-16 mx-auto sm:px-6 text-black p-5">

    <!-- header -->
    <div class="flex justify-center">
      <app-general-heading [header1]="'Reportar um caso'"></app-general-heading>
    </div>

    <div class="mt-4 mb-20 text-sm text-center text-gray-500">
      <p>Adicione todas a informações necessárias incluíndo os
        campos de informação para aumentar as chances de ser uma ocorrência bem sucedida.</p>
      <p>Certifique-se de preencher todos os campos obrigatórios.</p>
    </div>

    <!-- form section -->
    <app-event-form [apiErrors]="apiErrors"
                    [formStyle]="'lg:w-1/2 mx-auto mt-20'"
                    (onSubmitEvent)="submitForm($event)"
    ></app-event-form>

  </div>
</main>
